import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import './MetricsDashboard.css';
import MetricDateRangeSelector from './MetricDateRangeSelector';
import { Skeleton, Surface } from '../ui/Primitives';

function MetricsDashboard({ setAccountCallsCount }) {
  const [metrics, setMetrics] = useState({ calls: 0, averageDuration: 0, longestDuration: 0, totalDuration: 0, periodStart: '', periodEnd: '' });
  const [timeRange, setTimeRange] = useState('0');
  const [isLoading, setIsLoading] = useState(true);

  const fetchMetrics = useCallback(async (selectedTimeRange) => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_HOST}/metrics`, {
        jwt_token: localStorage.getItem('jwt_authorization'),
        timeRange: selectedTimeRange,
      });
      const { calls, averageDuration, longestDuration, totalDuration, periodEnd, periodStart, totalAccountCalls } = response.data;
      setMetrics({ calls, averageDuration, longestDuration, totalDuration, periodEnd, periodStart });
      setAccountCallsCount(totalAccountCalls);
    } catch (error) {
      console.error('Unable to load call metrics:', error);
    } finally {
      setIsLoading(false);
    }
  }, [setAccountCallsCount]);

  useEffect(() => { fetchMetrics(timeRange); }, [fetchMetrics, timeRange]);

  function onTimeRangeSelect(event) { setTimeRange(event.target.value); }

  const items = [
    { label: 'Calls answered', value: metrics.calls, detail: 'Handled by Sayable' },
    { label: 'Total minutes', value: metrics.totalDuration, detail: 'Across this period' },
    { label: 'Average call', value: metrics.averageDuration, detail: 'Typical duration' },
    { label: 'Longest call', value: metrics.longestDuration, detail: 'Longest conversation' },
  ];

  return (
    <Surface className="metrics-dashboard" data-say-id="metrics">
      <div className="metrics-toolbar">
        <div><span className="say-eyebrow">Call activity</span>{metrics.periodStart && <p>{metrics.periodStart} – {metrics.periodEnd}</p>}</div>
        <MetricDateRangeSelector onChange={onTimeRangeSelect} />
      </div>
      <div className="metrics-content">
        {items.map((item) => (
          <div className="metric-card" key={item.label}>
            <span>{item.label}</span>
            {isLoading ? <Skeleton width="55%" height={34} /> : <strong>{item.value ?? '—'}</strong>}
            <small>{item.detail}</small>
          </div>
        ))}
      </div>
    </Surface>
  );
}

export default MetricsDashboard;
